import { doc, DocumentSnapshot, Transaction, getDocFromServer } from 'firebase/firestore'
import firestore from '../../firestore'
import { CompanyPlanningRecord } from '@leadgen/models/client'
import BaseService from '../BaseService'

class CompanyPlanningRecordService extends BaseService {
  readonly pageSize = 50
  subscribeToCompanyPlanningRecord = async ({
    companyPlanningRecordId,
    companyId,
    onCompanyPlanningRecordUpdated,
  }: {
    onCompanyPlanningRecordUpdated: (template: CompanyPlanningRecord) => void
    companyPlanningRecordId: string
    companyId: string
  }) => {
    const {
      data,
      unsubscribe,
      doc: companyPlanningRecordDoc,
    } = await this.onDoc({
      ref: doc(firestore.companyPlanningRecords(companyId), companyPlanningRecordId),
      onUpdated: onCompanyPlanningRecordUpdated,
      forceServerResponse: true,
    })
    if (!companyPlanningRecordDoc.exists()) {
      throw new Error("Company planning record doesn't exist")
    }
    return {
      data: data as CompanyPlanningRecord,
      unsubscribe,
    }
  }
  fetchCompanyPlanningRecord = async ({
    companyPlanningRecordId,
    companyId,
    transaction,
  }: {
    transaction?: Transaction
    companyPlanningRecordId: string
    companyId: string
  }): Promise<CompanyPlanningRecord> => {
    const companyPlanningRecordRef = doc(
      firestore.companyPlanningRecords(companyId),
      companyPlanningRecordId,
    )
    let companyPlanningRecordDoc: DocumentSnapshot
    if (transaction) {
      companyPlanningRecordDoc = await transaction.get(companyPlanningRecordRef)
    } else {
      companyPlanningRecordDoc = await getDocFromServer(companyPlanningRecordRef)
    }
    if (!companyPlanningRecordDoc.exists()) {
      throw new Error("Company planning record doesn't exist")
    }
    return companyPlanningRecordDoc.data() as CompanyPlanningRecord
  }
}

export default new CompanyPlanningRecordService()
